<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('NILAI_TOEFL')" :class="{'form-group': true, 'has-error': errors.has('nilai_toefl')}">
        <label class="col-md-3"><span v-show="toeflRequired" class="required-label">*</span>Nilai TOEFL</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nilai_toefl"
            placeholder="Nilai TOEFL"
            class="form-control"
            maxlength="4"
            v-model="model.nilai_toefl"
            v-validate="isExist('NILAI_TOEFL') && toeflRequired ? 'required' : ''"
          >
          <span v-show="errors.has('nilai_toefl')" class="error-label">Isi Nilai TOEFL</span>
        </div>
      </div>
      <div v-show="isExist('NILAI_TOEFL')" class="form-group">
        <label class="col-md-3"><span v-show="toeflRequired" class="required-label">*</span>Sertifikat TOEFL</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointToefl"
            :headers="header"
            name="sertifikat_toefl"
            :data="dataUpload"
            :on-error="handleToeflError"
            :on-success="handleToeflSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_toefl"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="toeflUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="toeflUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('NILAI_TOAFL')" :class="{'form-group': true, 'has-error': errors.has('nilai_toafl')}">
        <label class="col-md-3"><span v-show="toaflRequired" class="required-label">*</span>Nilai TOAFL</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nilai_toafl"
            placeholder="Nilai TOAFL"
            class="form-control"
            maxlength="4"
            v-model="model.nilai_toafl"
            v-validate="isExist('NILAI_TOAFL') && toaflRequired ? 'required' : ''"
          >
          <span v-show="errors.has('nilai_toafl')" class="error-label">Isi Nilai TOAFL</span>
        </div>
      </div>
      <div v-show="isExist('NILAI_TOAFL')" class="form-group">
        <label class="col-md-3"><span v-show="toaflRequired" class="required-label">*</span>Sertifikat TOAFL</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointToafl"
            :headers="header"
            name="sertifikat_toafl"
            :data="dataUpload"
            :on-error="handleToaflError"
            :on-success="handleToaflSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_toafl"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="toaflUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="toaflUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('SCAN_KEPEMIMPINAN')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Curriculum Vitae (CV)</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointPendukung"
            :headers="header"
            name="sertifikat_pendukung"
            :data="dataUpload"
            :on-error="handlePendukungError"
            :on-success="handlePendukungSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_kepemimpinan"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="kepemimpinanUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="kepemimpinanUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      toaflRequired: false,
      toeflRequired: false,
      toaflUrl: null,
      toeflUrl: null,
      kepemimpinanUrl: null,
      model: {
        nilai_tpa: null,
        nilai_toafl: null,
        nilai_toefl: null
      },
      savedModel: null,
      file: {
        file_tpa: [],
        file_toafl: [],
        file_toefl: [],
        file_kepemimpinan: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointToefl () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_sertifikasi/toefl'
      } else {
        return 'test'
      }
    },
    docEndPointToafl () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_sertifikasi/toafl'
      } else {
        return 'test'
      }
    },
    docEndPointPendukung () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_sertifikasi/pendukung'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(21).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let fileToaflUploaded = this.file.file_toafl.length === 0
              let fileToeflUploaded = this.file.file_toefl.length === 0
              let fileCvUploaded = this.file.file_kepemimpinan.length === 0
              fileToaflUploaded && this.toaflRequired ? reject({message: 'belum ada scan sertifikat toafl'}) : false
              fileToeflUploaded && this.toeflRequired ? reject({message: 'belum ada scan sertifikat toefl'}) : false
              fileCvUploaded && this.isExist('SCAN_KEPEMIMPINAN') ? reject({message: 'belum ada file kepemimpinan'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 21)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.isExist('NILAI_TOAFL') ? this.toaflRequired = true : false
        this.isExist('NILAI_TOEFL') ? this.toeflRequired = true : false
        this.isExist('NILAI_TOAFL') ? this.getSertifikatToafl() : false
        this.isExist('NILAI_TOEFL') ? this.getSertifikatToefl() : false
        this.isExist('SCAN_KEPEMIMPINAN') ? this.getSertifikatPendukung() : false
        this.init = true
      }
    },
    handleToeflError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_toefl = [{name: 'toefl_' + this.nomorPendaftar + '.pdf'}]
        this.toeflUrl = 'Test'
        this.toeflRequired = true
        let fileToaflUploaded = this.file.file_toafl.length > 0
        fileToaflUploaded ? this.toaflRequired = true : this.toaflRequired = false
      }
    },
    handleToaflError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_toafl = [{name: 'toafl_' + this.nomorPendaftar + '.pdf'}]
        this.toaflUrl = 'Test'
        this.toaflRequired = true
        let fileToeflUploaded = this.file.file_toefl.length > 0
        fileToeflUploaded ? this.toeflRequired = true : this.toeflRequired = false
      }
    },
    handlePendukungError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_kepemimpinan = [{name: 'pendukung_' + this.nomorPendaftar + '.pdf'}]
        this.kepemimpinanUrl = 'Test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleToaflSuccess (res, file) {
      this.getSertifikatToafl()
      this.toeflRequired = false
      alert('upload sukses')
    },
    handleToeflSuccess (res, file) {
      this.getSertifikatToefl()
      this.toaflRequired = false
      alert('upload sukses')
    },
    handlePendukungSuccess (res, file) {
      this.getSertifikatPendukung()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    getData () {
      this.loading = true
      api.get('/v1/data_sertifikasi/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.model = data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getSertifikatToafl () {
      api.get('/v2/data_sertifikasi/toafl/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_toafl = [{name: 'toafl_' + this.nomorPendaftar + '.pdf'}]
            this.toaflUrl = responseData.url
            this.toaflRequired = true
            let fileToeflUploaded = this.file.file_toefl.length > 0
            fileToeflUploaded ? this.toeflRequired = true : this.toeflRequired = false
          }
        })
    },
    getSertifikatToefl () {
      api.get('/v2/data_sertifikasi/toefl/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_toefl = [{name: 'toefl_' + this.nomorPendaftar + '.pdf'}]
            this.toeflUrl = responseData.url
            this.toeflRequired = true
            let fileToaflUploaded = this.file.file_toafl.length > 0
            fileToaflUploaded ? this.toaflRequired = true : this.toaflRequired = false
          }
        })
    },
    getSertifikatPendukung () {
      api.get('/v2/data_sertifikasi/pendukung/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_kepemimpinan = [{name: 'pendukung_' + this.nomorPendaftar + '.pdf'}]
            this.kepemimpinanUrl = responseData.url
          }
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_sertifikasi', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataSertifikasi.vue